import { Card } from '@/shared/ui/Card'

interface BlockSkeletonProps {
  /** Quantas linhas de conteúdo simular. Aproxima a altura final do bloco. */
  rows?: number
}

/**
 * Carregamento dos blocos de sistema.
 *
 * Antes desta change cada bloco fazia `if (isLoading) return null`, e a home
 * montava de baixo para cima conforme cada fonte respondia — os blocos que já
 * tinham dado saltavam de posição. O placeholder ocupa o espaço do bloco para
 * que a ordem definida pelo produtor seja a ordem que o participante vê desde o
 * primeiro paint.
 */
export const BlockSkeleton = ({ rows = 2 }: BlockSkeletonProps) => (
  <Card className="card-gamification" aria-hidden>
    <Card.Body className="flex flex-col gap-3 px-4 py-4">
      <div className="h-4 w-1/3 animate-pulse rounded-md bg-gray-200" />
      {Array.from({ length: rows }).map((_row, index) => (
        <div
          key={index}
          className="h-10 w-full animate-pulse rounded-xl bg-gray-200"
        />
      ))}
    </Card.Body>
  </Card>
)
